import React, { useState, useEffect } from "react";

export const svg = `<svg width="20" height="20" viewbox="0 0 20 20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.25026 5.68963C7.28666 4.78795 8.61757 4.28682 10.0001 4.28682C11.3827 4.28682 12.7136 4.78792 13.7499 5.68955L15.3696 4.06984C14.6905 3.45485 13.91 2.96042 13.0617 2.60902C12.0911 2.20695 11.0507 2 10.0001 2C8.94955 2 7.90924 2.20695 6.93862 2.60902C6.0903 2.96044 5.30974 3.4549 4.63056 4.06993L6.25026 5.68963Z" fill="currentColor"></path><path d="M3.61698 5.17767L5.25567 6.81636C4.69224 7.65653 4.36041 8.63352 4.29781 9.64817C4.22661 10.8021 4.50695 11.9504 5.10183 12.9417L8.04367 9.99986L9.65438 6.25407V11.3234L6.47896 14.4984C7.48423 15.2847 8.72374 15.7118 9.99996 15.7118C11.2762 15.7118 12.5157 15.2847 13.521 14.4984L10.3459 11.3234V6.23447H10.3539L11.9563 9.99946L14.8973 12.9417C15.4925 11.9506 15.7731 10.8022 15.702 9.64827C15.6396 8.63362 15.3078 7.65661 14.7443 6.81646L16.383 5.17778C17.215 6.27893 17.7494 7.57871 17.9309 8.95155C18.1306 10.4617 17.8949 11.9976 17.2517 13.3784C16.6084 14.7593 15.5842 15.9278 14.2996 16.7465C13.015 17.5652 11.5233 18.0002 9.99996 18.0002C8.47662 18.0002 6.98494 17.5652 5.70032 16.7465C4.4157 15.9278 3.39154 14.7593 2.74827 13.3784C2.105 11.9976 1.86935 10.4617 2.06903 8.95155C2.25056 7.57867 2.785 6.27884 3.61698 5.17767Z" fill="currentColor"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
